{
  "title": "AI Assistant",
  "newChat": "New chat",
  "untitled": "Untitled",
  "emptyHint": "Ask about your farm's devices, fields, irrigation plans, or recent activity.",
  "placeholder": "Ask a question…",
  "send": "Send",
  "spend": "Spent ${{spent}} of ${{budget}} this month — ${{remaining}} remaining.",
  "budgetExceeded": "This farm has reached its monthly AI assistant budget.",
  "unavailable": "The AI assistant isn't available right now.",
  "experimental": "Experimental"
}
